<template>
    <div>
        
        <b-btn v-if="!cardReaderOnly && !cashOnly" class="font-weight-bold" block variant="danger" @click="showOrderInfo">
            Apply Payment
        </b-btn>
        <b-modal size="lg" no-fade centered hide-header hide-footer v-model="paymentModal" body-class="p-0" v-if="!cardReaderOnly && !cashOnly" @hide="onPaymentModalHide">
            <b-card no-body body-class="mb-0" class="mb-0">
                <b-tabs fill class="payment-tabs" ref="paymentTabs" @activate-tab="onActivateTab">
                    <b-tab v-if="!cardReaderOnly" title-link-class="p-3 font-weight-bold custom-tab" title="Punch In Card" :active="!cardReaders.length ? true : false" class="p-0" style="min-height: 420px">
                        <b-overlay :show="loading" rounded="sm">
                            <payment-form @generateToken="generateToken" :customer-name="order.CustomerName" @cancelOperation="paymentModal = !paymentModal" :fromReport="true"/>
                        </b-overlay>
                    </b-tab>
                    <b-tab v-if="!cardReaderOnly" title-link-class="p-3 font-weight-bold custom-tab" title="Text Payment Link" class="position-relative">
                        <div style="min-height: 420px" class="pt-4">
                            <confirm-phone-number
                                :updateOrderTime="updateOrderTime"
                                :getDate="getDate"
                                class="h-100" :fromReport="true" :TabNumber="order.TabNo" @cancelOperation="paymentModal = !paymentModal" :order-type="order.OrderType" :no-create-tab="true" @finalSendLink="finalSendLink" :CreateOrderModel="CreateOrderModel"/>
                        </div>
                    </b-tab>
                    <b-tab v-if="!cardReaderOnly" title-link-class="p-3 font-weight-bold custom-tab" title="Cash Pay" class="p-0" style="min-height: 420px">
                        <cash-pay
                            class="pt-5"
                            @cancelConfirmation="paymentModal = !paymentModal"
                            :Total="Total"
                            :tabNo="tabNo"
                            :tableNo="tableNo"
                            @OpenBox="OpenBox"
                            @closeAllPopUp="closeAll"
                            @printReceipt="setPrint"
                            :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                            :HasActiveTicketPrinter="HasActiveTicketPrinter"
                        />
                    </b-tab>
                    <b-tab v-if="!cardReaderOnly" title-link-class="p-3 font-weight-bold custom-tab" title="Other Pay" class="p-0" style="min-height: 420px">
                        <b-col class="pt-4">
                            <b-row class="d-flex flex-row justify-content-center">
                                <p v-if="isNaN(Total)" class="mb-0 h5 font-weight-bold text-dark">Total Payable: <b-spinner class="mb-2" small label="Medium Spinner"></b-spinner></p>
                                <p v-else class="mt-3 h5 font-weight-bold text-dark">Total Payable: $<span>{{ Total.toFixed(2) }}</span></p>
                            </b-row>
                            <b-row class="mt-2 d-flex flex-row justify-content-center">
                                <p class="font-lg">Please confirm the payable amount, select the payment source, and continue with payment.</p>
                            </b-row>
                            <b-row class="d-flex flex-row justify-content-center flex-wrap px-3 mb-3">
                                <b-btn
                                    v-for="option in otherPayList"
                                    :key="option.value"
                                    class="m-2 other-pay-btn"
                                    :class="otherPaySource === option.value ? 'activeBtn' : 'deactiveBtn'"
                                    @click="selectOtherPaySource(option.value)"
                                >
                                    {{ option.item }}
                                </b-btn>
                            </b-row>
                            <b-row class="d-flex flex-row justify-content-center px-3 mt-4 mb-2">
                                <b-input-group prepend="Reference ID">
                                    <b-input
                                        v-model="otherPayReferenceID"
                                        name="Reference ID"
                                        :disabled="otherPayLoading"
                                        placeholder="Optional"
                                        style="font-size: 1.15rem !important;"
                                    />
                                </b-input-group>
                            </b-row>
                            <b-row class="d-flex flex-row justify-content-center" v-if="otherPayErr">
                                <p class="font-lg text-danger">Please select a payment Source</p>
                            </b-row>
                            <b-row class="flex-grow-1 px-3 mt-4">
                                <b-col cols="6">
                                    <b-btn variant="warning" :disabled="otherPayLoading" block class="text-nowrap" @click="submitOtherPay">
                                        <span v-if="otherPayLoading">
                                            Processing...
                                            <b-spinner small class="ml-2 mb-2" label="Loading..."></b-spinner>
                                        </span>
                                        <span v-else>
                                            Continue with Payment
                                        </span>
                                    </b-btn>
                                </b-col>
                                <b-col cols="6">
                                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="otherPayLoading" @click="paymentModal = !paymentModal">
                                        Cancel
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-tab>
                    <b-tab v-if="cardReaders.length" :active="cardReaders.length ? true : false" title-link-class="p-3 font-weight-bold custom-tab" title="Pay with Card Reader" active lazy class="p-0" style="min-height: 420px">
                        <div v-if="!cardReaderPicked" class="pt-4 px-3">
                            <b-row class="d-flex flex-row justify-content-center mb-3">
                                <p class="font-weight-bold h5 mb-0">Please select a card reader</p>
                            </b-row>
                            <b-row class="d-flex flex-row justify-content-center ml-2" :style="{'overflow-y':'scroll !important'}">
                                <b-form-group label="" v-slot="{ ariaDescribedby }" class="mx-4">
                                    <b-form-radio-group
                                            v-model="selectedReader"
                                            :options="cardReaders"
                                            :aria-describedby="ariaDescribedby"
                                            name="Card reader"
                                            :style="{gap:'2rem'}"
                                            buttons
                                            size="lg"
                                            button-variant="outline-warning"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </b-row>
                            <b-row class="d-flex flex-row align-items-center justify-content-center mt-4" v-if="selectedReader">
                                <b-col cols="auto">
                                    <b-btn class="w-100 mt-3" style="font-size: 1.3em !important;height: 3rem !important;" @click="cardReaderPicked = true" :disabled="loading" variant="warning">
                                        Proceed To Payment
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </div>
                        <template v-else>
                            <b-row class="d-flex flex-row justify-content-end px-3 pt-2 mb-0">
                                <b-btn size="sm" variant="link" class="p-0" @click="changeReader">
                                    Change Card Reader
                                </b-btn>
                            </b-row>
                            <pay-card-reader
                                ref="cardReader"
                                @cancelConfirmation="paymentModal = !paymentModal"
                                @cancel="cancel"
                                :order="order"
                                @closeAllPopUp="closeAll"
                                :selectedReader="selectedReader"
                            />
                        </template>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-modal>





        
        <!-- if called from crete tab section you can choose from a list of reader -->
        <b-modal 
        @hide="hide"
        size="lg"
        centered
        title="Please select a card reader"
        v-model="cardReaderOnly"
        v-if="!proceededToCardReaderPay && !this.loading"
        hide-footer
        >
            <b-container>
                <b-row class="cetered ml-2" :style="{'overflow-y':'scroll !important'}">

                    <b-form-group label=""  v-slot="{ ariaDescribedby }" class="mx-4">
                            <b-form-radio-group
                                    v-model="selectedReader"
                                    :options="cardReaders"
                                    :aria-describedby="ariaDescribedby"
                                    name="Packaging type"
                                    :style="{gap:'2rem'}"
                                    buttons
                                    size="lg"
                                    button-variant="outline-warning"
                            ></b-form-radio-group>
                        </b-form-group>
                </b-row>
                <b-row class="d-flex flex-row align-items-center justify-content-center">
                    <b-col >
                        <b-btn class="w-100" @click="goToPay" :disabled="loading"  variant="warning">
                            Proceed 
                        </b-btn>
                    </b-col>
                    <b-col>
                        <b-btn class="w-100 cancel-btn-cmodal" :disabled="loading" :style="{color:'white'}" variant="secondary" @click="hide">
                            Cancel
                        </b-btn>
                    </b-col>
                </b-row>
                
            </b-container>
        </b-modal>


        <!-- if called from create tab and payment is in progress -->
        <b-modal v-if="proceededToCardReaderPay && !this.loading && orderInfoReady" size="lg" no-fade centered hide-header hide-footer v-model="paymentModal" body-class="p-0" no-close-on-backdrop @hide="onReaderModalHide">
                <pay-card-reader
                            ref="cardReader"
                            @cancelConfirmation="cancel"
                            @cancel="cancel"
                            :order="order"
                            @closeAllPopUp="closeAll"
                            :selectedReader="selectedReader"
                            :cardReaderOnly="cardReaderOnly"
                            @paymentCompleted="paymentCompleted"
                        />
        </b-modal>

        <!-- if called from the create tab and cash pay is selected -->
        <b-modal v-if="cashOnly" size="lg"  no-fade centered hide-header hide-footer v-model="paymentModal" body-class="p-0" @hide="cancel" >
            <b-container class="px-3 pt-3 pb-2 bg-light" :style="{'border-bottom': '1px solid grey'}">
                <h5 class="  ">Cash Pay</h5>
            </b-container>
        
            <b-container title-link-class="p-3 font-weight-bold custom-tab" title="Cash Pay" class="p-0" style="min-height: 15rem">
                        <cash-pay
                            class="pt-5"
                            @cancelConfirmation="cancel"
                            :Total="Total"
                            :tabNo="tabNo"
                            :tableNo="tableNo"
                            @OpenBox="OpenBox"
                            @closeAllPopUp="cashPayCloseAll"
                            @printReceipt="setPrint"
                            :HasActiveReceiptPrinter="HasActiveReceiptPrinter"
                            :HasActiveTicketPrinter="HasActiveTicketPrinter"
                            :cashOnly="true"
                            @setCashReturnAmmount="setCashReturnAmmount"
                        />
                    </b-container>
        </b-modal>

        

    </div>
</template>

<script>
    import PaymentForm from "../createOrder/paymentForm";
    import ConfirmPhoneNumber from "../createOrder/confirmPhoneNumber";
    import ConfirmDate from "../createOrder/confirmDate";
    import moment from 'moment'
    import CashPay from "../shared/cashPay";
    import PayCardReader from "../shared/PayCardReader";
    import CModal from "../shared/Cmodal";
    export default {
        name: "paymentOperation",
        data () {
            return {
                paymentModal: false,
                dateModal: false,
                stripeToken: null,
                nameOnCard: null,
                zipcodeCard: null,
                
                loading: false,
                confirmationData: {
                    orderType: '',
                    time: null,
                    date: null,
                    special:false
                },
                getDate: null,
                updateOrderTime: false,
                cardReaders: [],
                selectedReader: null,
                cardReaderPicked: false,
                proceededToCardReaderPay: false,
                orderInfoReady: false,
                // "Other Pay" tab state — mirrors src/components/createOrder/components/otherPay.vue
                otherPayLoading: false,
                otherPaySource: null,
                otherPayList: [],
                otherPayErr: false,
                otherPayReferenceID: null,
                tabSwitchAllowed: false,
            }
        },
        components: {CModal, PayCardReader, CashPay, ConfirmDate, ConfirmPhoneNumber, PaymentForm},
        props: {
            order: {required: true},
            isSpecial: {required: false},
            selectedFoodMenuType: {required: false},
            Total: {required: false},
            tabNo: {required: false},
            HasActiveReceiptPrinter: {required: false},
            HasActiveTicketPrinter: {required: false},
            tableNo: {required: false},
            cardReaderOnly:{default: false},
            cashOnly:{default:false},
            
            
        },
        computed: {
            CreateOrderModel () {
                if(!this.cardReaderOnly && !this.cashOnly){

                    return {
                        phoneNumber: this.order && this.order.Phone.includes('+1') ? this.order.Phone : '',
                        OrderID: this.order.OrderID
                    }
                }
            }
        },
        watch: {
            order: {
                handler(newVal, oldVal) {
                    const newOrderID = newVal && newVal.OrderID
                    const oldOrderID = oldVal && oldVal.OrderID
                    if(newOrderID && newOrderID !== oldOrderID){
                        this.orderInfoReady = true
                    }else if(!newOrderID){
                        this.orderInfoReady = false
                    }
                },
                deep: true,
                immediate: true
            },
           
        },
        mounted () {
            if(this.cardReaderOnly || this.cashOnly){
                this.showPaymentModal()
            }else{
                this.getPaySources()
            }
            
        },
        methods: {
            getPaySources(){
                return this.$api.getRestaurant.GetRestaurantProfile({RestaurantID: this.$store.state.selectedRestaurantId})
                .then((res) => {
                    
                    if (res.success) {
                        
                        if(res.OtherPaySources.length > 0){
                            this.otherPayList = res.OtherPaySources.map(source => ({item: source[1], value: source[0]}))
                        // Add "Other" as the first option
                        this.otherPayList.push({item: "Other", value: 5});
                
                        }else{
                            this.otherPaySources = []
                        }
                    }
                })
            },
            // The reader must be released (cancelReaderPayment) before leaving its tab, changing reader or closing
            releaseReader () {
                const reader = this.$refs.cardReader
                return reader ? reader.cancelReaderPayment() : Promise.resolve('released')
            },
            async onActivateTab (newIndex, prevIndex, bvEvent) {
                if (!this.$refs.cardReader || this.tabSwitchAllowed) return
                bvEvent.preventDefault()
                if (await this.releaseReader() !== 'released') return
                this.tabSwitchAllowed = true
                this.$refs.paymentTabs.tabs[newIndex].activate()
                this.tabSwitchAllowed = false
            },
            async changeReader () {
                if (await this.releaseReader() === 'released') {
                    this.cardReaderPicked = false
                }
            },
            // Closes by the user (outside click/Esc); v-model closes only happen once the reader is done
            isUserClose (bvEvent) {
                return !!this.$refs.cardReader && ['backdrop', 'esc', 'headerclose'].includes(bvEvent.trigger)
            },
            async onPaymentModalHide (bvEvent) {
                if (!this.isUserClose(bvEvent)) return
                bvEvent.preventDefault()
                if (await this.releaseReader() === 'released') {
                    this.paymentModal = false
                }
            },
            // Create Order reader pop-up: the order is only deleted (cancel → cancelPay) after the reader is released
            onReaderModalHide (bvEvent) {
                if (this.isUserClose(bvEvent)) return this.onPaymentModalHide(bvEvent)
                this.cancel()
            },
            paymentCompleted(){
                this.paymentModal = false
                this.$emit('updateReport')
            },
            hide(){
                this.$emit("cancelPay")
                this.reset()
            },
            goToPay(){
                this.loading = true
                setTimeout(() => {//second to wait for the order to be created(only when canceled and pay for second tmie)
                    this.readerSelected(this.selectedReader)
                    this.loading = false
                }, 2500)
            },
            readerSelected(reader){
                this.selectedReader = reader
                this.proceededToCardReaderPay = true
            },
            showOrderInfo () {
                this.showPaymentModal()
                // if (this.order.OrderTypeID === 2) {
                //
                // } else {
                //     this.showConfirmationDate()
                // }
            },
            showPaymentModal () {
                this.paymentModal = true
                this.GetRestaurantPOSs()
            },
            GetRestaurantPOSs () {
                this.loading = true
                this.cardReaders = []
                this.cardReaderPicked = false
                this.selectedReader = null
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    TableIKey: -1
                }
                return this.$api.getRestaurant.GetRestaurantPOSs(object).then(res => {
                    if (res.success) {
                        res.results.forEach(el => {
                            if(el.IsLinked != true){
                                this.cardReaders.push(el.POSName)
                            }
                        });
                        if(this.cardReaders.length === 0){
                            res.results.forEach(el => {
                                    this.cardReaders.push(el.POSName)
                            });
                        }
                        if(this.cardReaderOnly){
                            // Preselect the first reader so the existing card-reader-only picker keeps its prior behavior
                            this.selectedReader = this.cardReaders[0]
                            if(this.cardReaders.length === 1){
                                this.readerSelected(this.cardReaders[0])
                            }
                        } else if(this.cardReaders.length === 1){
                            this.selectedReader = this.cardReaders[0]
                            this.cardReaderPicked = true
                        }
                        // otherwise leave selectedReader unset so the tab's radio group starts unselected
                        this.loading = false
                    }
                })
            },
            showConfirmationDate () {
                if (this.isSpecial) {
                    let date = this.order.DueTime.split(' ')
                    let splitDate = date[0].split('/')
                    let newFormatDate = splitDate[2] + '-' + splitDate[0] + '-' + splitDate[1]
                    let dateObject = moment(newFormatDate).format('YYYY-MM-DD')
                    let getHour = date[1] + date[2]
                    let selfhour = getHour.substr(0, 4)
                    let formatHour = getHour.substr(7, 9)
                    let finalHour = selfhour + ' ' + formatHour
                    this.confirmationData = {
                        orderType: this.translateOrderType(this.order.OrderTypeID),
                        time: finalHour,
                        date: dateObject,
                        special: true,
                        specialMenuTypeId: this.selectedFoodMenuType
                    }
                    this.dateModal = true
                } else {
                    this.confirmationData = {
                        orderType: this.translateOrderType(this.order.OrderTypeID),
                        time: this.order.DueTime,
                        date: null,
                        special:false
                    }
                    this.dateModal = true
                }
            },
            translateOrderType (orderType) {
                if (orderType === 3) {
                    return 'Delivery'
                } else if (orderType === 1) {
                    return 'Pickup'
                }
            },
            createFinalyOrder (data) {
                this.getDate = this.isSpecial ? data.date + ' ' + data.time : data.time
                let model = {
                    PickupTime: this.getDate,
                    OrderID: this.order.OrderTypeID,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                }
                this.loading = true
                this.$api.diner.UpdateOrderPickupTime(model).then(res => {
                    this.loading = false
                    if (res.success) {
                        let data = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            OrderID: this.order.OrderID,
                            OrderStatusID: this.order.OrderStatusID,
                            phoneNumber:  this.order.Phone,
                            nameOnCard: this.nameOnCard,
                            stripeToken: this.stripeToken
                        }
                        this.dateModal = false
                        this.addPayment(data)
                    }
                }).catch(err => {
                    this.loading = false
                })
                // this.updateOrderTime = true
                // this.dateModal = false
                // this.paymentModal = true
            },
            cancel () {
                console.log("called")
                this.dateModal = false
                this.confirmationData = {
                    orderType: '',
                        time: null,
                        date: null,
                        special:false
                }
                if(this.cardReaderOnly){
                    this.reset()
                }

                try{
                    this.$emit("cancelPay")
                }catch{
                    console.log('error occured')
                }
            },
            generateToken (stripeToken) {
                if (this.order.OrderTypeID !== 2) {
                    // this.changeDateOfOrder(stripeToken)
                    this.stripeToken = stripeToken.token
                    this.nameOnCard = stripeToken.nameOnCard
                    this.zipcodeCard = stripeToken.zipcode
                    if (this.stripeToken) {
                        this.showConfirmationDate()
                    }
                } else {
                    // pay dine in order
                    this.stripeToken = stripeToken.token
                    this.nameOnCard = stripeToken.nameOnCard
                    this.zipcodeCard = stripeToken.zipcode
                    let data = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        OrderID: this.order.OrderID,
                        OrderStatusID: this.order.OrderStatusID,
                        phoneNumber:  this.order.Phone,
                        nameOnCard: this.nameOnCard,
                        stripeToken: this.stripeToken
                    }
                    if (this.stripeToken) {
                        this.loading = true
                        this.addPayment(data)
                    }
                }
            },
            changeDateOfOrder (stripeToken) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: this.order.OrderID,
                    PickupTime: this.getDate
                }
                this.$api.getRestaurant.UpdateOrderPickupTime(model).then(res => {
                    if (res.success) {
                        this.stripeToken = stripeToken.token
                        this.nameOnCard = stripeToken.nameOnCard
                        this.zipcodeCard = stripeToken.zipcode
                        this.loading = true
                        let data = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            OrderID: this.order.OrderID,
                            OrderStatusID: this.order.OrderStatusID,
                            phoneNumber:  this.order.Phone,
                            nameOnCard: this.nameOnCard,
                            stripeToken: this.stripeToken
                        }
                        this.addPayment(data)
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            addPayment (data) {
                this.loading = true
                return this.$api.getRestaurant.AddPaymentMethod(data).then(res => {
                    if (res.success) {
                        // this.$showSuccess('successfully')
                        this.PayOrder(data)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {})
            },
            PayOrder (orderInfo) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: orderInfo.OrderID,
                    phoneNumber:  orderInfo.phoneNumber,
                    PaymentMethod: 'card'
                }
                return this.$api.getRestaurant.PayOrder(model).then(res => {
                    if (res.success) {
                        this.confirmPay(res, orderInfo)
                    } else {
                        this.$showError(res.message)
                        this.loading = false
                    }
                }).catch(() => {
                    this.$showError('error in pay order')
                    this.loading = false
                })
            },
            confirmPay (info, orderInfo) {
                var stripe = Stripe(this.$config.stripeToken, {
                    stripeAccount: info.ConnectedAccountID
                })
                stripe.confirmCardPayment(info.ClientSecret, {
                    payment_method: info.PaymentMethod
                }).then(res => {
                    // A decline resolves with { error }; leave the order unpaid so staff can retry
                    if (res.error) {
                        this.$showError(res.error.message)
                        this.loading = false
                        return
                    }
                    this.UpdateTransaction(res, info, orderInfo)
                }).catch(err => {
                    this.$showError('error on confirm date: ' + err)
                    this.loading = false
                })

            },
            UpdateTransaction (confirmPayData, payOrderInfo, orderInfo) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: orderInfo.OrderID,
                    phoneNumber:  orderInfo.phoneNumber,
                    ReceiptNumber: confirmPayData.paymentIntent.created,
                    PaymentMmethod: payOrderInfo.PaymentMethod
                }
                this.$api.getRestaurant.UpdateTransaction(model).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.paymentModal = false
                        this.$emit('updateReport')
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(err => {
                    this.loading = false
                    this.$showError('error in updateTransaction: ' + err)
                })
            },
            finalSendLink () {
                this.paymentModal = false
                this.$emit('updateReport')
            },
            OpenBox () {
                const model = {
                    OrderId: this.order.OrderID,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    PaymentStatusID:4
                }
                this.$emit('openCashBox')

                this.$api.getRestaurant.UpdateOrderCashPaid(model, true).then(res => {
                    if (!res.success) {
                        this.$showError(res.message)
                    } 
                    
                })
            },
            cashPayCloseAll(){
                this.paymentModal = false
                this.$emit('updateReport')
            },
            closeAll () {
                console.log("called close all in PO")
                if(this.cashOnly){
                    this.paymentModal = false
                    return this.$emit('cancelPay')
                }
                this.paymentModal = false
                this.$emit('updateReport')
                console.log("close all called≈")

            },
            setPrint () {
                
                this.paymentModal = false
                this.$emit('getReceipt')
            },
            reset(){
                this.paymentModal= false
                this.dateModal= false
                this.stripeToken= null
                this.nameOnCard= null
                this.zipcodeCard= null
                
                this.loading= false
                this.confirmationData= {
                    orderType: '',
                    time: null,
                    date: null,
                    special:false
                }
                this.getDate= null
                this.updateOrderTime= false
                this.cardReaders= []
                this.selectedReader= null
                this.cardReaderPicked= false
                this.proceededToCardReaderPay= false
                this.otherPayLoading= false
                this.otherPaySource= null
                this.otherPayReferenceID= null
                this.otherPayErr= false
            },
            setCashReturnAmmount(payBackMoney){
                
                this.$emit("setCashReturnAmmount",payBackMoney)
            },
            selectOtherPaySource(value){
                if(this.otherPayLoading){
                    return
                }
                this.otherPaySource = value
            },
            submitOtherPay(){
                if(isNaN(this.Total)){
                    return
                }
                this.otherPayErr = false
                if(this.otherPaySource === null && this.otherPayList.length > 0){
                    this.otherPayErr = true
                    return
                }
                this.otherPayLoading = true
                
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: this.order.OrderID,
                    PaymentStatusID:this.otherPaySource,
                    
                }
                
                if(this.otherPayReferenceID){
                    model.OtherPayTransaction = this.otherPayReferenceID
                }
                return this.$api.getRestaurant.UpdateOrderCashPaid(model).then(res=>{
                    if(res.success){
                        this.cashPayCloseAll()
                        this.resetOtherPay(true)
                    }
                }).catch(err=>{
                    this.$showError(err.message)
                    this.otherPayLoading = false
                })
                
            },
            
            resetOtherPay(success){
                this.otherPayLoading = false
                if(success){
                    this.otherPaySource = null
                    this.otherPayReferenceID = null
                    this.paymentModal = false
                    this.$emit('updateReport')
                }
            }
        }
    }
</script>

<style lang="scss">
    .custom-tab{
        font-size: 1rem;
    }
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        color: #000 !important;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #5b5f62 !important;
        color: #5b5f62 !important;
    }
    .other-pay-btn {
        min-width: 10rem;
        font-size: 1.5rem;
    }
</style>
